<!-- <div class="nav-link-group"><a [routerLink]="['/signup']" class="nav-link-item"> Start Free Trial </a></div> -->
<div class="logo animated fadeIn faster" id="logo">
    <img src="/assets/img/pelican_logo.png" alt="Wise Pelican Logo" />
</div>
<div class="main-content" style="margin-top: 10px">
    <div class="container-fluid">
        <div class="wp-container">
            <div class="card wp-card" *ngIf="!forgotPassword">
                <h4 class="wp-card-title text-center">Log In to Wise Pelican</h4>
                <div class="card-body wp-card-body">
                    <!-- <form #loginForm="ngForm" class="clearfix"> -->
                    <form class="clearfix">
                        <!-- <div class="wp-card-body-row" style="margin-bottom: 10px;">
                            <i class="material-icons">person</i>
                            <input ngModel type="email" required name="username" class="form-control" #username="ngModel" placeholder="Username" />
                        </div> -->
                        <div class="wp-card-body-row" style="margin-bottom: 10px">
                            <mat-form-field appearance="outline" style="width: 100%">
                                <mat-label>Email</mat-label>
                                <input matInput [formControl]="loginFormControls.email" name="email" #emailLoginElement (input)="errorMessage = ''" />
                                <mat-icon matSuffix>email</mat-icon>
                                <mat-error> {{ getControlErrorMessage(loginFormControls.email) }} </mat-error>
                            </mat-form-field>
                        </div>
                        <!-- <div class="wp-card-body-row">
                            <i class="material-icons">lock_outline</i>
                            <input ngModel type="password" required name="password" class="form-control" #password="ngModel" placeholder="Password" />
                        </div> -->
                        <div class="wp-card-body-row">
                            <mat-form-field appearance="outline" style="width: 100%">
                                <mat-label>Password</mat-label>
                                <input matInput [formControl]="loginFormControls.password" name="password" type="password" (input)="errorMessage = ''" />
                                <mat-icon matSuffix>lock_outline</mat-icon>
                                <mat-error> {{ getControlErrorMessage(loginFormControls.password) }} </mat-error>
                            </mat-form-field>
                        </div>

                        <div *ngIf="errorMessage" style="color: red; text-align: center" class="mat-typography">
                            {{ errorMessage }}
                        </div>

                        <button
                            mat-flat-button
                            color="primary"
                            class="login-button"
                            (click)="onLoginButtonClicked()"
                            [disabled]="isLoggingIn || isResettingPassword"
                            [appIndeterminateButtonLoading]="isLoggingIn"
                        >
                            Log In
                        </button>
                    </form>

                    <div class="mat-typography">
                        <div class="login-footer" (click)="onResetPasswordFooterClick()">
                            <span class="text-center" alt="Reset Password">Reset Password</span>
                        </div>
                        <div class="login-footer" style="margin-top: 10px; margin-bottom: 5px">
                            <span class="text-center"><a href="/signup" alt="Create Account">Sign up</a></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card wp-card" *ngIf="forgotPassword">
                <h4 class="wp-card-title text-center">Reset Password</h4>
                <div class="card-body wp-card-body">
                    <form #resetForm="ngForm" class="clearfix">
                        <div *ngIf="!isResetEmailSent" class="wp-card-body-row">
                            <mat-form-field appearance="outline" style="width: 100%">
                                <mat-label>Email</mat-label>
                                <input matInput [formControl]="resetPasswordFormControl.email" name="email" #emailResetElement />
                                <mat-icon matSuffix>email</mat-icon>
                                <mat-error> {{ getControlErrorMessage(resetPasswordFormControl.email) }} </mat-error>
                            </mat-form-field>
                        </div>
                        <div *ngIf="forgotMessage" class="mat-typography" style="margin-bottom: 20px">
                            {{ forgotMessage }}
                        </div>

                        <button
                            *ngIf="!isResetEmailSent"
                            mat-flat-button
                            color="primary"
                            class="login-button"
                            (click)="onResetPasswordButtonClick()"
                            [disabled]="isResettingPassword || isLoggingIn"
                            [appIndeterminateButtonLoading]="isResettingPassword"
                        >
                            Reset Password
                        </button>
                    </form>
                    <div class="mat-typography login-footer" (click)="onReturnToLoginFooterClick()">
                        <span>Back</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
